module.exports = __webpack_public_path__ + "media/about/jake-9e8bed59.jpg";